/**
 * Created by 唐亦慧 on 2018/2/8.
 */
import React from 'react';
import {hashHistory} from 'react-router';
import Reflux from 'reflux';
import '../mallApp.css';
import './product.css';
import {
    Breadcrumb,
    Tabs,
    message,
    Spin,
    Rate,
    Checkbox,
} from 'antd';
import {TableView} from 'Components';
import {
    readCount,
} from '../../service/mall';
import {
    commodityDetail,
    transactionRecord,
} from '../../service/merchandise';
import {
    addFavoritesList,
    deleteFavoritesList,
    getProductComment,
    getProductCommentCount,
    getProductDetails,
} from '../../service/product';
import {
    productActions,
    productStore,
} from '../mallHome/store';
import {
    openNotice,
    returnFloat,
    config,
} from 'Utils';

const TabPane = Tabs.TabPane;
const productLineName = {
    '01': '元器件',
    '02': '电工',
    '03': '电表',
    '04': '变频器',
    '05': '天e',
    '06': 'TG精品',
};
const imgData = {
    'photoImg': require('../../assets/images/ic-dy-man03.png'),
};

class ProductDetail extends Reflux.Component {
    constructor(props) {
        super(props);
        this.store = Reflux.initStore(productStore);
        this.id = props.params.id;
        this.productId = props.params.productId;
        this.inIframe = /^\/mallSelect/.test(props.location.pathname);
        this.state = {
            requestFlag: false,
            imgKey: 0,
            detail: {}, // 商品详情
            productDetail: {}, // 默认产品详情
            commentData: {},
            maxKey: this.props.location.query.maxKey || '',
            maxKeyWord: '',
            minKey: this.props.location.query.minKey || '',
            minKeyWord: '',
            /*keys: null, //规格选择*/
            keys: [],
            lables: ['', '新品', '推荐', '热销', '爆款'], //活动
            defaultActiveKey: '1',
            quantity: 1, //数量文本框
            specList: [], //规格参数
            isShow: true, //是否显示库存
            zeroAdd: true, //0库存是否可下单
            isMinus: false,//是否可减
            hasSpec: true, //是否存在该种规格产品
            recordObj: {
                commodityId: this.id,
                p: 1,
                s: 20,
            },
            rows: [],
            total: 0,
        };
        this.imgChange = this.imgChange.bind(this);
        this.goView = this.goView.bind(this);
        this.getDetail = this.getDetail.bind(this);
        this.getRecord = this.getRecord.bind(this);
        this.getReadCount = this.getReadCount.bind(this);
        this.setCollection = this.setCollection.bind(this);
        this.refreshProductComment = this.refreshProductComment.bind(this);
    }

    //页面跳转
    goView(keyWord) {
        hashHistory.push('/mallHome');
    }

    componentDidMount() {
        this.getDetail();
        this.getRecord();
        this.getProductDetail();
        this.refreshProductComment();
    }

    tabClickFn(key) {
        /* 页签点击 */
        this.setState({
            'defaultActiveKey': key,
        });
    }

    //浏览次数
    getReadCount() {
        readCount({id: parseInt(this.id, 10)}).then((result) => {
            if (!result.status) {
                message.error(result.message);
            }
        });
    }

    refreshProductComment() {
        let self = this;
        getProductCommentCount(this.productId).then(result => {
            let resultData = result.data || {};
            let commentCount = 0;
            for (let field in resultData) {
                commentCount += resultData[field];
            }
            resultData.commentCount = commentCount;
            resultData.data = [];
            self.setState({
                commentData: resultData,
            });
            if (result && result.code == 200) {
                getProductComment(this.productId).then(resultList => {
                    if (resultList && resultList.code == 200) {
                        self.setState({
                            'commentData': {
                                ...self.state.commentData,
                                'data': resultList.data || [],
                            },
                        });
                    } else {
                        openNotice('error', '评论获取失败', (resultList && resultList.message) ? resultList.message : '');
                    }
                });
            } else {
                openNotice('error', '评论获取失败', (result && result.message) ? result.message : '');
            }
        });
    }

    //获取详情
    getProductDetail() {
        if (this.productId) {
            getProductDetails({id: this.productId}).then(res => {
                if (res.status) {
                    this.setState({
                        productDetail: res.data,
                    });
                }
            });
        }
    }

    getDetail() {
        commodityDetail({id: this.id}).then((result) => {
            var specList = [];
            if (result.status) {
                let data = result.data || {};
                data.picMainList = (data.picMainList || []).map(x => ({
                    ...x,
                    file_path: `${config.server}${x.file_path}`,
                    file_preview_path: `${config.server}${x.file_preview_path}`,
                    file_compress_path: `${config.server}${x.file_compress_path}`,
                })); // 主图
                data.picPreviewList = (data.picPreviewList || []).map(x => ({
                    ...x,
                    file_path: `${config.server}${x.file_path}`,
                    file_preview_path: `${config.server}${x.file_preview_path}`,
                    file_compress_path: `${config.server}${x.file_compress_path}`,
                })); // 缩略图
                this.setState({
                    detail: data,
                    maxKeyWord: data.bigName || '',
                    minKeyWord: data.middleName || '',
                    specList,
                });
                /*var newQuantity = 0;
                 const { setFieldsValue } = this.props.form;
                 if (result.data.minimumPacking > result.data.minimumOrderQuantity) {
                 newQuantity = result.data.minimumPacking;
                 } else {
                 if (result.data.minimumOrderQuantity % result.data.minimumPacking == 0) {
                 newQuantity = result.data.minimumOrderQuantity;
                 } else {
                 newQuantity = (parseInt((result.data.minimumOrderQuantity / result.data.minimumPacking), 10) - 0 + 1) * result.data.minimumPacking;
                 }
                 }*/
                /*this.setState({
                 quantity: newQuantity,
                 });*/
                // setFieldsValue({
                //   proNum: newQuantity,
                // });
                // if (result.data.categoryText) {
                //   const categoryArr = result.data.categoryText.split(',');
                //   this.setState({
                //     maxKeyWord: categoryArr[0],
                //     minKeyWord: categoryArr[1] || '',
                //   });
                // }
                // if (result.data.pathIds) {
                //   const pathIdsArr = result.data.pathIds.split(',');
                //   this.setState({
                //     maxKey: pathIdsArr[0].toString(),
                //     minKey: pathIdsArr[1] ? pathIdsArr[1].toString() : '',
                //   });
                // }
            } else {
                message.error(result.message);
            }
        });
    }

    imgChange(key) {
        this.setState({
            imgKey: key,
        });
    }

    setCollection() {
        const {productDetail, detail} = this.state;
        console.log('debug detail.isCollection: ', productDetail.isCollection);
        if (productDetail.isCollection === 1) {
            deleteFavoritesList([{productId: productDetail.id, commodityId: detail.id}]).then(res => {
                res.status && this.getProductDetail();
                openNotice(res.status ? 'success' : 'error', res.message || '');
            });
        } else {
            addFavoritesList([{productId: productDetail.id, commodityId: detail.id}]).then(res => {
                res.status && this.getProductDetail();
                openNotice(res.status ? 'success' : 'error', res.message || '');
            });
        }
    }

    pageChange = (page, pageSize) => {
        const self = this;
        this.setState({recordObj: {...this.state.recordObj, s: pageSize, p: page}}, function () {
            self.getRecord();
        });
    };

    getRecord() {
        transactionRecord(this.state.recordObj).then(res => {
            if (res.status) {
                this.setState({total: res.total, rows: res.data});
            } else {
                console.error(res.message);
            }
        });
    }

    render() {
        const self = this;
        const {
            isShow, zeroAdd, minKeyWord, maxKeyWord, imgKey, detail, lables, defaultActiveKey,
            requestFlag, productDetail, commentData, total, rows, recordObj,
        } = this.state;
        let commentHtml = (commentData.data || []).map(function (qst, key) {
            var imgH = (qst.picFileList || []).map(function (q, k) {
                if (!q) {
                    return '';
                }
                return <img style={{cursor: 'pointer'}}
                            onClick={self.openImg.bind(self, config.server + q.fileCompressPath)}
                            key={k} alt="" src={config.server + q.fileCompressPath}/>;
            });
            return <li key={qst.id}>
                <img alt=""
                     src={qst.isAnonymity === 1 ? imgData['photoImg'] : (qst.picUrl ? (config.server + qst.picUrl) : imgData['photoImg'])}/>
                <span className="na">{qst.isAnonymity === 1 ? '匿名用户' : qst.evaluator}</span>
                <div>
                    <p className="na">{qst.evaluation || '好评！'}</p>
                    {imgH}
                    <p><span>{qst.createdDate}</span><span>{qst.spec}</span></p>
                </div>
            </li>;
        });
        const tableViewProps = {
            loading: false,//更新表格数据中
            rowKey: 'id',
            pageParam: {
                total,
                current: recordObj.p,//当前页码
                pageSize: recordObj.s,//当前分页数
                onChange: this.pageChange,
            },
            columns: [
                {
                    title: '',
                    dataIndex: 'imgUrl',
                    width: '30%',
                    render: text => <img className='cart-img'
                                         src={text || require('../../assets/images/product-default.png')}
                                         alt=""/>
                }, {
                    title: '名称',
                    dataIndex: 'productName',
                }, {
                    title: '下单时间',
                    width: 160,
                    dataIndex: 'createdDate',
                },
            ],
            rows,
        };
        return <Spin spinning={requestFlag} tip="请求中，请等待..." size='large'>
            {
                !!detail.name &&
                <div className={this.inIframe ? '' : 'product-content'}>
                    <div className="content-top">
                        {!this.inIframe && <div className='content-title'>
                            {
                                this.store.state.searchMallData.keyword ?
                                    <Breadcrumb separator=">">
                                        <Breadcrumb.Item style={{cursor: 'pointer'}}
                                                         onClick={this.goView.bind(this, 'home')}>首页</Breadcrumb.Item>
                                        <Breadcrumb.Item>{`搜索“${this.store.state.searchMallData.keyword}”`}</Breadcrumb.Item>
                                        <Breadcrumb.Item>{maxKeyWord}</Breadcrumb.Item>
                                        <Breadcrumb.Item>{minKeyWord}</Breadcrumb.Item>
                                        <Breadcrumb.Item>{detail.name}</Breadcrumb.Item>
                                    </Breadcrumb>
                                    :
                                    <Breadcrumb separator=">">
                                        <Breadcrumb.Item style={{cursor: 'pointer'}}
                                                         onClick={this.goView.bind(this, 'home')}>首页</Breadcrumb.Item>
                                        <Breadcrumb.Item style={{cursor: 'pointer'}}
                                                         onClick={this.goView.bind(this, 'first')}>{maxKeyWord}</Breadcrumb.Item>
                                        <Breadcrumb.Item style={{cursor: 'pointer'}}
                                                         onClick={this.goView.bind(this, 'second')}>{minKeyWord}</Breadcrumb.Item>
                                        <Breadcrumb.Item>{detail.name}</Breadcrumb.Item>
                                    </Breadcrumb>
                            }
                        </div>}

                        <div className="detail-main">
                            <div className="main-left">
                                <img
                                    src={detail.picMainList && detail.picMainList.length > 0 ? (detail.picMainList[imgKey].file_path) : require('../../assets/images/product-default.png')}
                                    className="max-img"
                                    alt='图片加载失败'/>
                                <div className="img-list">
                                    {
                                        (detail.picMainList || []).map((value, key) => {
                                            return <div className={key == imgKey ? 'selected-img' : ''} key={key}
                                                        onMouseEnter={this.imgChange.bind(this, key)}><img
                                                src={value.file_path}
                                                alt='图片加载失败'/>
                                            </div>;
                                        })
                                    }
                                </div>
                            </div>
                            <div className="main-right detail_field">
                                <div className="pro-title clear">
                                    {
                                        detail.labeling > 0 &&
                                        <span className="is-activity">{lables[detail.labeling]}</span>
                                    }
                                    <span className="title-main">{detail.name}</span>
                                </div>
                                <div className="price">
                                    <div className="price-left">
                                        <span> 牌价：{returnFloat(detail.showPrice)}</span>
                                        {
                                            detail.active == 0 &&
                                            <span style={{
                                                fontSize: '16px',
                                                color: '#000',
                                                marginLeft: '20px',
                                            }}>此商品已下架</span>
                                        }
                                    </div>
                                    <div className="price-right">
                                        <p>
                                            {
                                                detail.active == 'Active' && ((!isShow && !zeroAdd) || isShow) &&
                                                <span>库存</span>
                                            }
                                            {
                                                detail.active == 'Active' && ((!isShow && !zeroAdd) || isShow) ?
                                                    (
                                                        isShow ?
                                                            <span>{detail.inventory}</span>
                                                            :
                                                            (
                                                                (!isShow && !zeroAdd) ?
                                                                    (
                                                                        detail.inventory > 0 ?
                                                                            <span>有货</span>
                                                                            :
                                                                            <span>缺货</span>
                                                                    )
                                                                    :
                                                                    ''
                                                            )
                                                    )
                                                    :
                                                    ''
                                            }
                                        </p>
                                        <p>
                                            <span>总销量</span>
                                            <span>{productDetail.salesVolume}</span>
                                        </p>
                                    </div>
                                </div>
                                {
                                    detail.promotion &&
                                    <div className="rules">
                                        <span>促销</span>
                                        <span>{`${detail.promotion.promotionSubject}${detail.promotion.startTime && detail.promotion.endTime ? ' 仅限 ' : ''}${detail.promotion.startTime || ''}${detail.promotion.startTime && detail.promotion.endTime ? ' - ' : ''}${detail.promotion.endTime || ''} ${detail.promotion.quantityLimit || detail.promotion.quantityLimit == 0 ? '总量：' : ''}${detail.promotion.quantityLimit ? detail.promotion.quantityLimit : (detail.promotion.quantityLimit == 0 ? '无限制' : '')}${detail.promotion.quantityLimit ? detail.unitText : ''} ${detail.promotion.personalLimit || detail.promotion.personalLimit == 0 ? '每人限购：' : ''}${detail.promotion.personalLimit ? detail.promotion.personalLimit : (detail.promotion.personalLimit == 0 ? '无限制' : '')}${detail.promotion.personalLimit ? detail.unitText : ''}`}</span>
                                    </div>
                                }
                                <div className="de">
                                    <ul className="left">
                                        <li>
                                            <label>物料编码</label>
                                            <p>{productDetail.itemNum}</p>
                                        </li>
                                        <li>
                                            <label>单位</label>
                                            <p>{productDetail.unit}</p>
                                        </li>
                                        <li>
                                            <label>最小装箱数</label>
                                            <p>{productDetail.minPackageQuantity}</p>
                                        </li>
                                        <li>
                                            <label>装箱数</label>
                                            <p>{productDetail.packageQuantity}</p>
                                        </li>
                                        {/* <li>
                      <label>每小盒数量</label>
                      <p>{productDetail.sortOrder}</p>
                    </li> */}
                                    </ul>
                                    <ul className="right">
                                        <li>
                                            <label>产品线</label>
                                            <p>{productLineName[productDetail.proLine]}</p>
                                        </li>
                                        <li>
                                            <label>物料大类</label>
                                            <p>{productDetail.proBigName}</p>
                                        </li>
                                        <li>
                                            <label>库存类型</label>
                                            <p>{productDetail.stockType}</p>
                                        </li>
                                        <li>
                                            <label>最小起订量</label>
                                            <p>{productDetail.minOrderQuantity}</p>
                                        </li>
                                    </ul>
                                </div>
                                <div className="all-button">
                                    <div onClick={this.setCollection} className="collection">
                                        <i className={`comIcon${!!productDetail.isCollection ? ' dmsFullStar' : ' dmsStar'}`}></i>
                                        <span>{!!productDetail.isCollection ? '已收藏' : '收藏'}</span>
                                    </div>
                                    <div className="cart"
                                         onClick={() => hashHistory.push(`/${this.inIframe ? 'mallSelect' : 'mallCommon'}/productDetail/${this.id}/${this.productId}/select`)}>
                                        <span>规格选型</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="detail_other tab_individual">
                        <Tabs className="my-ant-tabs" activeKey={defaultActiveKey}
                              onChange={this.tabClickFn.bind(this)}>
                            <TabPane tab="产品详情" key="1" forceRender={true}>
                                {
                                    !!(productDetail.graphicDetails || detail.imageTextDetail) ?
                                        <div className="img-content">
                                            <div
                                                dangerouslySetInnerHTML={{__html: productDetail.graphicDetails || detail.imageTextDetail}}></div>
                                        </div>
                                        :
                                        <div style={{
                                            width: '100%',
                                            height: '400px',
                                            textAlign: 'center',
                                            position: 'relative',
                                        }}>
                                            <img style={{
                                                width: '200px',
                                                height: '200px',
                                                position: 'absolute',
                                                top: '28px',
                                                left: '50%',
                                                marginLeft: '-100px',
                                            }} src={require('../../assets/images/null.png')} alt=""/>
                                            <p style={{
                                                width: '100%',
                                                height: '274px',
                                                paddingTop: '250px',
                                                textAlign: 'center',
                                                lineHeight: '24px',
                                                fontSize: '18px',
                                                color: '#999',
                                            }}>暂无图文详情</p>
                                        </div>
                                }
                            </TabPane>
                            <TabPane tab="产品参数" key="2" forceRender={true}>
                                {
                                    !!(productDetail.parameter || detail.commodityParameters) ?
                                        <div className="img-content">
                                            <div
                                                dangerouslySetInnerHTML={{__html: productDetail.parameter || detail.commodityParameters}}></div>
                                        </div>
                                        :
                                        <div style={{
                                            width: '100%',
                                            height: '400px',
                                            textAlign: 'center',
                                            position: 'relative',
                                        }}>
                                            <img style={{
                                                width: '200px',
                                                height: '200px',
                                                position: 'absolute',
                                                top: '28px',
                                                left: '50%',
                                                marginLeft: '-100px',
                                            }} src={require('../../assets/images/null.png')} alt=""/>
                                            <p style={{
                                                width: '100%',
                                                height: '274px',
                                                paddingTop: '250px',
                                                textAlign: 'center',
                                                lineHeight: '24px',
                                                fontSize: '18px',
                                                color: '#999',
                                            }}>暂无产品参数</p>
                                        </div>
                                }
                            </TabPane>
                            <TabPane tab="产品资料" key="3">
                                <div style={{padding: '12px', background: '#fff'}}>
                                    <p>附件：</p>
                                    {(productDetail.fileUrls || []).map(function (qst, key) {
                                        return <div key={key} style={{margin: '4px'}}>
                                            <a href={`${config.server}${qst.file_path.replace("getFile", "getFileDown")}`}>
                                                {qst.fileName}
                                            </a>
                                        </div>;
                                    })}
                                </div>
                            </TabPane>
                            {/*<TabPane tab={'累计评价（' + (commentData.commentCount || 0) + '）'} key="4">
                <div className="product_comment">
                  <div className="star">
                    <span>评价</span>
                    <ul>
                      <li>
                        <Rate disabled defaultValue={5} /><span>{commentData.fiveCount || 0}</span>
                      </li>
                      <li>
                        <Rate disabled defaultValue={4} /><span>{commentData.fourCount || 0}</span>
                      </li>
                      <li>
                        <Rate disabled defaultValue={3} /><span>{commentData.threeCount || 0}</span>
                      </li>
                      <li>
                        <Rate disabled defaultValue={2} /><span>{commentData.twoCount || 0}</span>
                      </li>
                      <li>
                        <Rate disabled defaultValue={1} /><span>{commentData.oneCount || 0}</span>
                      </li>
                    </ul>
                  </div>
                  <div className="list">
                    <ul>
                      {commentHtml}
                    </ul>
                  </div>
                </div>
              </TabPane>*/}
                            <TabPane tab="成交记录" key="5">
                                <div style={{padding: '12px', background: '#fff'}}>
                                    <TableView {...tableViewProps} />
                                </div>
                            </TabPane>
                        </Tabs>
                    </div>
                </div>
            }
        </Spin>;
    }
}
;
export default ProductDetail;



// WEBPACK FOOTER //
// ./src/mall/mallDetail/merchandiseDetail.js